// SEMENTARA — preview UI/UX schedule baru (admin sahaja), buang bila migrate ke /workspace
import React, { useState } from 'react';
import { auth } from '../firebase';
import { getUserRole, canAccessAdmin } from '../utils/roles';
import TemplateJadualModal, { DEFAULT_TEMPLATES, formatDateMs } from './TemplateJadualModal';

const MOCK_PRODUCTS = [
    {
        id: 1,
        sku: '1735312879593232100',
        title: 'Umpan Semut Ant Bait Roach Killer',
        gradient: 'linear-gradient(135deg, #fecaca, #f87171)',
        avatarGradient: 'linear-gradient(135deg, #fbcfe8, #ec4899)',
    },
    {
        id: 2,
        sku: '1735312879593232200',
        title: 'DRY Pro Baju Hujan Motorcycle Rainsuit Coat, Rainsuit, Motorcycle',
        gradient: 'linear-gradient(135deg, #fde68a, #f59e0b)',
        avatarGradient: 'linear-gradient(135deg, #c7d2fe, #6366f1)',
    },
    {
        id: 3,
        sku: '1735312879593232300',
        title: 'Official Glow Skin Toner Hydrating Brightening',
        gradient: 'linear-gradient(135deg, #c7d2fe, #6366f1)',
        avatarGradient: 'linear-gradient(135deg, #bbf7d0, #22c55e)',
    },
    {
        id: 4,
        sku: '1735312879593232400',
        title: 'TOYO-G Dirt Off Heavy-Duty Cleaner 500ml',
        gradient: 'linear-gradient(135deg, #bbf7d0, #22c55e)',
        avatarGradient: 'linear-gradient(135deg, #fde68a, #f59e0b)',
    },
    {
        id: 5,
        sku: '1735312879593232500',
        title: 'Premium Vitamin C Serum 30ml Anti-Aging',
        gradient: 'linear-gradient(135deg, #fbcfe8, #ec4899)',
        avatarGradient: 'linear-gradient(135deg, #fecaca, #f87171)',
    },
];

const MODULE_PILLS = [
    { id: 'ai8saat', label: 'AI8SAAT', color: '#f43f5e' },
    { id: 'ai16saat', label: 'AI16SAAT', color: '#3b82f6' },
    { id: 'homeniche', label: 'HOME NICHE', color: '#10b981' },
    { id: 'goyang', label: 'GOYANG', color: '#f59e0b' },
    { id: 'smart', label: 'SMART', color: '#a855f7', badge: 'NEW' },
];

const estimateEndDate = (startDate, slotsPerDay, totalVideos) => {
    if (!startDate || slotsPerDay <= 0) return null;
    const days = Math.max(0, Math.ceil(totalVideos / slotsPerDay) - 1);
    const d = new Date(startDate);
    d.setDate(d.getDate() + days);
    return d.toISOString().slice(0, 10);
};

const ProductCard = ({ product }) => (
    <div className="bg-white rounded-xl border border-slate-200 p-3 flex items-center gap-3 hover:border-slate-300 transition">
        <input
            type="checkbox"
            className="w-4 h-4 rounded border-slate-300 text-rose-500 focus:ring-rose-200 shrink-0"
        />
        <div className="w-14 h-14 rounded-lg shrink-0" style={{ background: product.gradient }} />
        <div className="w-9 h-9 rounded-full shrink-0 border-2 border-white shadow-sm" style={{ background: product.avatarGradient }} />
        <div className="flex-1 min-w-0">
            <div className="text-sm font-bold text-slate-800 truncate">
                <span className="text-slate-400">#{product.sku}</span> {product.title}
            </div>
            <div className="text-xs text-blue-500 hover:underline flex items-center gap-1 mt-0.5 cursor-pointer w-fit">
                <span className="material-symbols-outlined" style={{ fontSize: 12 }}>link</span>
                shop.tiktok.com
            </div>
            <div className="flex gap-1.5 mt-2 flex-wrap">
                <button className="px-2.5 py-1 text-[10px] font-bold text-amber-700 bg-amber-50 rounded-md flex items-center gap-1 hover:bg-amber-100 transition">
                    <span className="material-symbols-outlined" style={{ fontSize: 12 }}>terminal</span>
                    Full Prompt
                </button>
                <button className="px-2.5 py-1 text-[10px] font-bold text-slate-600 bg-slate-100 rounded-md flex items-center gap-1 hover:bg-slate-200 transition">
                    <span className="material-symbols-outlined" style={{ fontSize: 12 }}>open_in_new</span>
                    EXT
                </button>
                <button className="px-2.5 py-1 text-[10px] font-bold text-amber-700 bg-amber-50 rounded-md flex items-center gap-1 hover:bg-amber-100 transition">
                    <span className="material-symbols-outlined" style={{ fontSize: 12 }}>refresh</span>
                    RETRY
                </button>
                <button className="px-2.5 py-1 text-[10px] font-bold text-rose-600 bg-rose-50 rounded-md flex items-center gap-1 hover:bg-rose-100 transition">
                    <span className="material-symbols-outlined" style={{ fontSize: 12 }}>bolt</span>
                    AI8SAAT
                </button>
            </div>
        </div>
    </div>
);

const WorkspaceV38View = () => {
    // ═══ Admin guard — non-admin nampak 404 ═══
    const userRole = getUserRole(auth.currentUser?.email);
    if (!canAccessAdmin(userRole)) {
        return (
            <div className="h-screen flex items-center justify-center bg-slate-50">
                <div className="text-center">
                    <h1 className="text-5xl font-bold text-slate-800 mb-2">404</h1>
                    <p className="text-slate-500">Page not found</p>
                </div>
            </div>
        );
    }

    // ═══ State (UI only, zero backend) ═══
    const [activeTab, setActiveTab] = useState('tiktok');
    const [activeModule, setActiveModule] = useState('ai8saat');
    const [leftTab, setLeftTab] = useState('tiktok'); // mini Flow/TikTok tab in left panel
    const [whenToPost, setWhenToPost] = useState('schedule');
    const [showWhenDropdown, setShowWhenDropdown] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [postOnly, setPostOnly] = useState(false);
    const [showcase, setShowcase] = useState(false);

    const [templates, setTemplates] = useState(DEFAULT_TEMPLATES);
    const [activeTemplateId, setActiveTemplateId] = useState('akaun-1');
    const activeTemplate = templates.find(t => t.id === activeTemplateId);
    const slotsCount = activeTemplate
        ? activeTemplate.slots.length + (activeTemplate.customTimes?.length || 0)
        : 0;

    const totalVideos = MOCK_PRODUCTS.length * 3; // 1 generation = 3 sets
    const endDate = slotsCount > 0
        ? estimateEndDate(activeTemplate?.startDate, slotsCount, totalVideos)
        : null;
    const daysNeeded = slotsCount > 0 ? Math.ceil(totalVideos / slotsCount) : 0;
    const exceedsLimit = daysNeeded > 10;

    return (
        <div className="h-screen flex flex-col md:flex-row bg-slate-50 overflow-hidden">
            {/* ═══════════════ LEFT PANEL ═══════════════ */}
            {/* Telefon: panel jadi jalur atas setinggi 38vh, bukan lajur 288px. */}
            <aside className="w-full md:w-72 max-h-[38vh] md:max-h-none bg-white border-b md:border-b-0 md:border-r border-slate-200 flex flex-col overflow-hidden shrink-0">
                {/* Module pills */}
                <div className="px-3 pt-4 pb-3 flex gap-1.5 flex-wrap">
                    {MODULE_PILLS.map(m => (
                        <button
                            key={m.id}
                            onClick={() => setActiveModule(m.id)}
                            className={`px-2.5 py-1 rounded-lg text-[10px] font-bold flex items-center gap-1 transition relative ${
                                activeModule === m.id
                                    ? 'text-white shadow-sm'
                                    : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                            }`}
                            style={activeModule === m.id ? { background: m.color } : {}}
                        >
                            {m.label}
                            {m.badge && (
                                <span className="absolute -top-1 -right-1 text-[8px] font-bold px-1 rounded bg-amber-400 text-white shadow">
                                    {m.badge}
                                </span>
                            )}
                        </button>
                    ))}
                </div>

                {/* Input textarea */}
                <div className="px-4 pb-3">
                    <textarea
                        placeholder="Or add new product data or script here..."
                        className="w-full px-3 py-2 text-xs border border-slate-200 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-slate-200 placeholder:text-slate-400"
                        rows={3}
                    />
                </div>

                {/* Library button */}
                <div className="px-4 pb-3">
                    <button className="w-full px-3 py-2 text-xs font-semibold text-slate-600 bg-slate-50 hover:bg-slate-100 rounded-lg flex items-center gap-2 transition">
                        <span className="material-symbols-outlined" style={{ fontSize: 16 }}>library_books</span>
                        Library
                    </button>
                </div>

                {/* Generate button */}
                <div className="px-4 pb-3">
                    <button
                        className="w-full px-4 py-3 text-sm font-bold text-white rounded-xl shadow-md hover:shadow-lg transition flex items-center justify-center gap-1.5"
                        style={{ background: 'linear-gradient(135deg, #8b5cf6, #6366f1)' }}
                    >
                        <span className="material-symbols-outlined" style={{ fontSize: 18 }}>add</span>
                        Generate
                    </button>
                </div>

                {/* Mini Flow / TikTok tab */}
                <div className="px-4 mb-2 flex gap-1 border-b border-slate-100">
                    <button
                        onClick={() => setLeftTab('flow')}
                        className={`flex-1 py-2 text-xs font-semibold transition flex items-center justify-center gap-1 border-b-2 ${
                            leftTab === 'flow'
                                ? 'text-indigo-600 border-indigo-500'
                                : 'text-slate-400 hover:text-slate-600 border-transparent'
                        }`}
                    >
                        <span className="material-symbols-outlined" style={{ fontSize: 14 }}>merge</span>
                        Flow
                    </button>
                    <button
                        onClick={() => setLeftTab('tiktok')}
                        className={`flex-1 py-2 text-xs font-semibold transition flex items-center justify-center gap-1 border-b-2 ${
                            leftTab === 'tiktok'
                                ? 'text-rose-500 border-rose-500'
                                : 'text-slate-400 hover:text-slate-600 border-transparent'
                        }`}
                    >
                        <span className="material-symbols-outlined" style={{ fontSize: 14 }}>music_note</span>
                        TikTok
                    </button>
                </div>

                {/* TIKTOK QUEUE label */}
                <div className="px-4 pb-2">
                    <div className="text-[9px] font-bold text-slate-400 tracking-widest">
                        TIKTOK QUEUE
                    </div>
                </div>

                {/* Dummy products list */}
                <div className="flex-1 overflow-y-auto px-3 pb-3 space-y-1">
                    {MOCK_PRODUCTS.map(p => (
                        <div
                            key={p.id}
                            className="px-2 py-1.5 rounded-lg hover:bg-slate-50 cursor-pointer flex items-center gap-2 transition"
                        >
                            <div className="w-8 h-8 rounded-md shrink-0" style={{ background: p.gradient }} />
                            <div className="min-w-0 flex-1">
                                <div className="text-[11px] font-semibold text-slate-700 truncate">
                                    {p.title}
                                </div>
                                <div className="text-[9px] text-slate-400 truncate">#{p.sku}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </aside>

            {/* ═══════════════ MAIN AREA ═══════════════ */}
            <main className="flex-1 flex flex-col overflow-hidden min-w-0">
                {/* ── Tab pills bar ── */}
                <div className="px-6 py-3 border-b border-slate-200 bg-white flex items-center justify-between">
                    <div className="inline-flex items-center bg-slate-100 rounded-xl p-1">
                        {[
                            { id: 'all', label: 'All', count: MOCK_PRODUCTS.length, icon: 'grid_view' },
                            { id: 'flow', label: 'Flow', count: 0, icon: 'merge' },
                            { id: 'tiktok', label: 'Tiktok', count: MOCK_PRODUCTS.length, icon: 'music_note' },
                            { id: 'chatgpt', label: 'ChatGPT', count: 0, icon: 'smart_toy' },
                        ].map(tab => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`px-3 py-1.5 rounded-lg text-sm font-bold flex items-center gap-2 transition ${
                                    activeTab === tab.id
                                        ? 'bg-white text-slate-800 shadow-sm'
                                        : 'text-slate-500 hover:text-slate-700'
                                }`}
                            >
                                <span className="material-symbols-outlined" style={{ fontSize: 18 }}>{tab.icon}</span>
                                {tab.label}
                                <span className="text-xs font-bold opacity-60">{tab.count}</span>
                            </button>
                        ))}
                    </div>
                    <div className="text-xs text-slate-400 font-mono">/workspace-v3.8</div>
                </div>

                {/* ── Scrollable card area ── */}
                <div className="flex-1 overflow-y-auto px-6 py-6 min-h-0">
                    <div className="max-w-4xl mx-auto space-y-3">
                        {activeTab === 'tiktok' ? (
                            MOCK_PRODUCTS.map(p => <ProductCard key={p.id} product={p} />)
                        ) : (
                            <div className="text-center py-20 text-slate-400">
                                <span className="material-symbols-outlined block mb-2" style={{ fontSize: 64 }}>inbox</span>
                                <p className="text-sm font-semibold">Preview only on TikTok tab</p>
                                <p className="text-xs mt-1">Switch to TikTok tab to see the new schedule toolbar</p>
                            </div>
                        )}
                    </div>
                </div>

                {/* ═══════════════ STICKY BOTTOM TOOLBAR (TikTok tab only) ═══════════════ */}
                {activeTab === 'tiktok' && (
                    <div className="border-t border-slate-200 bg-white" style={{ boxShadow: '0 -4px 16px rgba(0,0,0,0.04)' }}>
                        {/* Chip summary row */}
                        <div className="px-6 py-2.5 flex items-center gap-2 text-xs flex-wrap">
                            {whenToPost === 'schedule' && activeTemplate ? (
                                <>
                                    <div className="flex items-center gap-1.5 px-3 py-1.5 bg-slate-50 rounded-full text-slate-600 border border-slate-200">
                                        <span
                                            className="w-2 h-2 rounded-full shrink-0"
                                            style={{ background: activeTemplate.color }}
                                        />
                                        <span className="font-bold">{activeTemplate.name}</span>
                                        <span className="text-slate-300">·</span>
                                        <span className="font-semibold">{slotsCount} slots/day</span>
                                        <span className="text-slate-300">·</span>
                                        <span>Start {formatDateMs(activeTemplate.startDate)}</span>
                                        {endDate && (
                                            <>
                                                <span className="text-slate-300">·</span>
                                                <span>End {formatDateMs(endDate)}</span>
                                            </>
                                        )}
                                    </div>
                                    {exceedsLimit && (
                                        <div className="flex items-center gap-1.5 px-3 py-1.5 bg-amber-50 rounded-full text-amber-700 border border-amber-200">
                                            <span className="material-symbols-outlined" style={{ fontSize: 14 }}>warning</span>
                                            <span className="font-semibold">
                                                {totalVideos} videos × {slotsCount} slots = {daysNeeded} days (exceeds TikTok 10-day limit)
                                            </span>
                                        </div>
                                    )}
                                </>
                            ) : whenToPost === 'now' ? (
                                <div className="text-slate-500 italic px-2 py-1">
                                    Videos will be posted immediately when you press Run TikTok.
                                </div>
                            ) : null}
                            {postOnly && (
                                <div className="flex items-center gap-1.5 px-3 py-1.5 bg-rose-50 rounded-full text-rose-700 border border-rose-200">
                                    <span className="material-symbols-outlined" style={{ fontSize: 14 }}>description</span>
                                    <span className="font-semibold">Post Only</span>
                                </div>
                            )}
                            {showcase && (
                                <div className="flex items-center gap-1.5 px-3 py-1.5 bg-amber-50 rounded-full text-amber-700 border border-amber-200">
                                    <span className="material-symbols-outlined" style={{ fontSize: 14 }}>storefront</span>
                                    <span className="font-semibold">Showcase</span>
                                </div>
                            )}
                        </div>

                        {/* Toolbar row */}
                        <div className="px-6 py-3 flex items-center gap-3 border-t border-slate-100">
                            <div className="text-xs font-semibold text-slate-600 shrink-0">When To Post</div>

                            {/* When-to-post dropdown */}
                            <div className="relative">
                                <button
                                    onClick={() => setShowWhenDropdown(v => !v)}
                                    className="px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm font-semibold text-slate-700 flex items-center gap-2 hover:border-slate-300 transition min-w-[240px]"
                                >
                                    {whenToPost === 'now' ? (
                                        <>
                                            <span className="material-symbols-outlined text-slate-500" style={{ fontSize: 16 }}>bolt</span>
                                            <span>Post Now</span>
                                        </>
                                    ) : (
                                        <>
                                            <span className="material-symbols-outlined text-slate-500" style={{ fontSize: 16 }}>event</span>
                                            <span>Schedule</span>
                                            {activeTemplate && (
                                                <>
                                                    <span className="text-slate-300">·</span>
                                                    <span
                                                        className="w-2 h-2 rounded-full"
                                                        style={{ background: activeTemplate.color }}
                                                    />
                                                    <span className="text-slate-700">{activeTemplate.name}</span>
                                                </>
                                            )}
                                        </>
                                    )}
                                    <span
                                        className="material-symbols-outlined text-slate-400 ml-auto"
                                        style={{ fontSize: 16 }}
                                    >
                                        expand_more
                                    </span>
                                </button>

                                {showWhenDropdown && (
                                    <>
                                        {/* Backdrop to close on click outside */}
                                        <div
                                            className="fixed inset-0 z-10"
                                            onClick={() => setShowWhenDropdown(false)}
                                        />
                                        <div className="absolute bottom-full mb-2 left-0 w-72 bg-white rounded-xl shadow-2xl border border-slate-200 overflow-hidden z-20">
                                            <button
                                                onClick={() => {
                                                    setWhenToPost('now');
                                                    setShowWhenDropdown(false);
                                                }}
                                                className="w-full px-4 py-3 text-left hover:bg-slate-50 flex items-start gap-3 transition border-b border-slate-100"
                                            >
                                                <span
                                                    className="material-symbols-outlined text-slate-500 mt-0.5"
                                                    style={{ fontSize: 20 }}
                                                >
                                                    bolt
                                                </span>
                                                <div>
                                                    <div className="text-sm font-semibold text-slate-800">Post Now</div>
                                                    <div className="text-xs text-slate-500 mt-0.5">
                                                        Upload videos immediately without scheduling
                                                    </div>
                                                </div>
                                            </button>
                                            <button
                                                onClick={() => {
                                                    setWhenToPost('schedule');
                                                    setShowWhenDropdown(false);
                                                    // Bonus #3: auto-open popup bila takda template
                                                    if (templates.length === 0) setShowModal(true);
                                                }}
                                                className="w-full px-4 py-3 text-left hover:bg-slate-50 flex items-start gap-3 transition"
                                            >
                                                <span
                                                    className="material-symbols-outlined text-slate-500 mt-0.5"
                                                    style={{ fontSize: 20 }}
                                                >
                                                    event
                                                </span>
                                                <div>
                                                    <div className="text-sm font-semibold text-slate-800">Schedule</div>
                                                    <div className="text-xs text-slate-500 mt-0.5">
                                                        Schedule based on selected template
                                                    </div>
                                                </div>
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>

                            {/* Gear icon — muncul bila Schedule dipilih */}
                            {whenToPost === 'schedule' && (
                                <button
                                    onClick={() => setShowModal(true)}
                                    className="p-2 rounded-lg bg-white border border-slate-200 text-slate-600 hover:border-rose-300 hover:text-rose-500 hover:bg-rose-50 transition flex items-center gap-1.5"
                                    title="Setting Schedule"
                                >
                                    <span className="material-symbols-outlined" style={{ fontSize: 18 }}>settings</span>
                                    <span className="text-xs font-semibold pr-1">Setting Schedule</span>
                                </button>
                            )}

                            {/* Separator */}
                            <div className="w-px h-6 bg-slate-200 mx-1" />

                            {/* Post Only toggle */}
                            <button
                                onClick={() => setPostOnly(v => !v)}
                                title="Post caption only, skip video upload"
                                className={`px-3 py-1.5 rounded-lg text-xs font-semibold flex items-center gap-1.5 border transition ${
                                    postOnly
                                        ? 'bg-rose-50 text-rose-700 border-rose-300 hover:bg-rose-100'
                                        : 'bg-white text-slate-500 border-slate-200 hover:border-slate-300'
                                }`}
                            >
                                <span className="material-symbols-outlined" style={{ fontSize: 16 }}>description</span>
                                Post Only
                            </button>

                            {/* Showcase toggle */}
                            <button
                                onClick={() => setShowcase(v => !v)}
                                title="Post to Showcase tab only"
                                className={`px-3 py-1.5 rounded-lg text-xs font-semibold flex items-center gap-1.5 border transition ${
                                    showcase
                                        ? 'bg-amber-50 text-amber-700 border-amber-300 hover:bg-amber-100'
                                        : 'bg-white text-slate-500 border-slate-200 hover:border-slate-300'
                                }`}
                            >
                                <span className="material-symbols-outlined" style={{ fontSize: 16 }}>storefront</span>
                                Showcase
                            </button>

                            {/* Spacer */}
                            <div className="flex-1" />

                            {/* Run TikTok button — oren primary CTA */}
                            <button
                                className="px-5 py-2.5 bg-orange-500 hover:bg-orange-600 text-white text-sm font-bold rounded-lg shadow-md transition flex items-center gap-2"
                            >
                                <span className="material-symbols-outlined" style={{ fontSize: 18 }}>play_arrow</span>
                                Run TikTok
                            </button>
                        </div>
                    </div>
                )}
            </main>

            {/* ═══════════════ MODAL ═══════════════ */}
            <TemplateJadualModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                templates={templates}
                setTemplates={setTemplates}
                activeId={activeTemplateId}
                setActiveId={setActiveTemplateId}
            />
        </div>
    );
};

export default WorkspaceV38View;
